import { files } from 'dropbox';
import {
  BaseStorageItem,
  getMimeTypeFromFile,
  ServiceProvider,
  StorageItemMetadata,
  UPLOADCAM_FOLDER_MIME,
  UPLOADCAM_UNKNOWN_MIME,
} from '@uploadcam/common';

export type DropboxFile = files.FileMetadataReference | files.FolderMetadataReference;

export class DropboxItem extends BaseStorageItem {
  constructor(private readonly file: DropboxFile) {
    super();
  }

  public get provider(): ServiceProvider {
    return ServiceProvider.Dropbox;
  }

  public get id(): string {
    return this.file.id;
  }

  public get driveId(): string | undefined {
    return undefined;
  }

  public get parentId(): string | undefined {
    return this.file.path_lower
      ? this.file.path_lower.split('/').slice(0, -1).join('/') || '/'
      : undefined;
  }

  public get allowsSubfolderCreation(): boolean {
    return this.isFolder;
  }

  public get isVirtual(): boolean {
    return false;
  }

  public get mime(): string {
    if (this.isShortcut) {
      // invariant(this.file['.tag'] === 'file');
      // invariant(typeof this.file.symlink_info !== 'undefined');

      // const symlinkInfo = this.file.symlink_info;

      // TODO: get symlinked file mime
      return UPLOADCAM_UNKNOWN_MIME;
    } else if (this.file['.tag'] === 'folder') {
      return UPLOADCAM_FOLDER_MIME;
    } else if (this.file['.tag'] === 'file') {
      const mime = getMimeTypeFromFile(this.file.name);

      if (mime) {
        return mime.type;
      }

      return UPLOADCAM_UNKNOWN_MIME;
    }

    return UPLOADCAM_UNKNOWN_MIME;
  }

  public get name(): string {
    return this.file.name;
  }

  public get lastModified(): Date | undefined {
    if (this.file['.tag'] === 'file') {
      return new Date(this.file.client_modified);
    } else {
      return undefined;
    }
  }

  public get isShortcut(): boolean {
    if (this.file['.tag'] === 'file') {
      return typeof this.file.symlink_info !== 'undefined';
    }

    return false;
  }

  public get metadata(): StorageItemMetadata {
    return {};
  }

  public get size(): number | undefined {
    if (this.file['.tag'] === 'file') {
      return this.file.size;
    }

    return undefined;
  }
}
